export function navigateOnClick(event, url, history) {
    if (event.metaKey || event.ctrlKey) {
        window.open(url, '_blank');
        return;
    }

    if (window.getSelection().toString().length > 0) {
        return;
    }

    history.push(url);
}
